
import React, { useState } from "react";
import CTable from "components/common/Table";
import Button from "components/common/Button";
import CheckInDrawer from "./CheckInDrawer";

const CheckInTablebycustomer = ({
  toggleDrawer,
  data,
  opentoggle,
  visit_id,
  dropdownData,
  handlecheckinsubmit,
}) => {
  const [detail, setDetail] = useState("");
  const [editdraweropen, seteditDrawerOpen] = useState("");
  const handlesetdata = (name,details) => {
    toggleDrawer(true);
    seteditDrawerOpen(name);
    setDetail(details);
   
  };
  const columns = [
    {
      field: "charging_station",
      headerName: 'Charging Station'
    },
    {
      field: "charging_networks",
      headerName:'Network'
    },
    {
      field: "session_status",
      headerName:'Trip'
    },
    {
      field: "connector",
      headerName: 'Connector'
    },
    {
      field: "date",
      headerName:'Data'
    },
    {
      field: "time",
      headerName:'Charging Time'
    },
    {
      field: "units_charged",
      headerName:'Unit Charged'
    },
    {
      field: "amount",
      headerName: 'Amount'
    },
    {
      field: "invoice",
      headerName: "Invoice",
      valueGetter: (v, d) => {
        const manufacturer = {
          // pathname: "/add/details",
          station_id: d?.station_id,
          connector_id: d?.connector_id,
          date: d?.date,
          units_charged: d?.units_charged,
          amount: d?.amount,
          time: d?.time,
          user_id: d?.user_id,
          charging_station:d?.charging_station,
          invoice_url:d?.invoice_url
          // user_id:d.user_id,
        };
        return (
          <>
            {
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  // onClick={() => toggleDrawer(true)}
                  onClick={() => handlesetdata("addDetails",manufacturer)}
                  style={{
                    fontSize: "11px",
                    width: "150px",
                    textTransform: "none",
                  }}
                >
                  +Add  details
                </Button>
                {/* {manufacturer.invoice_url && ( */}
                <a href={manufacturer.invoice_url}>
                  <img
                    src="/download-icon-customer.svg"
                    alt="Download Invoice"
                    style={{ marginLeft: "5px", width: "27px" }}
                  />
                </a>
              {/* )} */}
              </div>
            }
          </>
        );
      },
    },
  ];
  return (
    <>
      <CTable
        columns={columns}
        data={data}
        // isLoading={loading?.isLoading}
        pagination={true}
        localPagination={true}
        page={0}
        rowsPerPage={5}
      />
      <CheckInDrawer
      data={data}
      editdraweropen={editdraweropen}
        detail={detail}
        visit_id={visit_id}
        toggleDrawer={toggleDrawer}
        drawerOpen={opentoggle}
        connnectorData={dropdownData}
        handlecheckinsubmit={handlecheckinsubmit}
      />
    </>
  );
};

export default CheckInTablebycustomer;

